import React, { useState } from "react"

interface BookingFormProps {
  service: any
  onSubmit: (bookingData: any) => void
  onCancel: () => void
}

export function BookingForm({ service, onSubmit, onCancel }: BookingFormProps) {
  const [formData, setFormData] = useState({
    date: "",
    time: "",
    duration: "",
    location: "",
    notes: ""
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const bookingData = {
      serviceId: service._id,
      serviceName: service.name,
      date: formData.date,
      time: formData.time,
      duration: formData.duration ? parseInt(formData.duration) : undefined,
      location: formData.location,
      notes: formData.notes,
      requiresPayment: service.requiresPayment,
      paymentAmount: service.requiresPayment ? 
        (service.paymentType === 'deposit' ? service.depositAmount : service.price) : 0
    }
    onSubmit(bookingData)
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000000,
      }}
      onClick={onCancel}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "24px",
          maxWidth: "400px",
          width: "90%",
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "16px" }}>
          Book {service.name}
        </h3>
        
        {service.requiresPayment && (
          <div style={{ 
            backgroundColor: "#f3f4f6", 
            padding: "12px", 
            borderRadius: "6px", 
            marginBottom: "16px" 
          }}>
            <p style={{ fontSize: "14px", fontWeight: "500", marginBottom: "4px" }}>
              Payment Required
            </p>
            <p style={{ fontSize: "14px", color: "#6b7280" }}>
              {service.paymentType === 'deposit' 
                ? `Deposit: ${service.currency || 'USD'} ${service.depositAmount}` 
                : `Full Payment: ${service.currency || 'USD'} ${service.price}`}
            </p>
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {service.requiredFields?.date !== false && (
            <div>
              <label style={{ display: "block", marginBottom: "4px", fontSize: "14px", fontWeight: "500" }}>
                Date
              </label>
              <input
                type="date"
                value={formData.date}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                required={service.requiredFields?.date !== false}
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              />
            </div>
          )}

          {service.requiredFields?.time && (
            <div>
              <label style={{ display: "block", marginBottom: "4px", fontSize: "14px", fontWeight: "500" }}>
                Time
              </label>
              <input
                type="time"
                value={formData.time}
                onChange={(e) => setFormData({ ...formData, time: e.target.value })}
                required={service.requiredFields?.time}
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              />
            </div>
          )}

          {service.requiredFields?.duration && (
            <div>
              <label style={{ display: "block", marginBottom: "4px", fontSize: "14px", fontWeight: "500" }}>
                Duration (minutes)
              </label>
              <input
                type="number"
                value={formData.duration}
                onChange={(e) => setFormData({ ...formData, duration: e.target.value })}
                required={service.requiredFields?.duration}
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              />
            </div>
          )}

          {service.requiredFields?.location && (
            <div>
              <label style={{ display: "block", marginBottom: "4px", fontSize: "14px", fontWeight: "500" }}>
                Location
              </label>
              <input
                type="text"
                value={formData.location}
                onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                required={service.requiredFields?.location}
                placeholder="Location or address"
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              />
            </div>
          )}

          {service.requiredFields?.notes !== false && (
            <div>
              <label style={{ display: "block", marginBottom: "4px", fontSize: "14px", fontWeight: "500" }}>
                Notes {service.requiredFields?.notes ? '(Required)' : '(Optional)'}
              </label>
              <textarea
                value={formData.notes}
                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                required={service.requiredFields?.notes}
                rows={3}
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                  resize: "vertical",
                }}
              />
            </div>
          )}

          <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
            <button
              type="button"
              onClick={onCancel}
              style={{
                flex: 1,
                padding: "10px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                backgroundColor: "white",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                flex: 1,
                padding: "10px 16px",
                border: "none",
                borderRadius: "6px",
                backgroundColor: "#3b82f6",
                color: "white",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Book Now
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}